import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { Home } from './Home';
import Login from "./Login";
import User from "./User";
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './components/Auth';

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Switch>
          <Route exact path="/aziende" component={Home} />
          <Route path="/aziende/:id" component={Home}/>
          <Route exact path="/recensioni/all" component={Home} />
          <Route exact path="/recensioni/weed" component={Home} />
          <Route exact path="/recensioni/hash" component={Home} />
          <Route exact path="/community" component={Home} />
          <Route exact path="/community/:id" component={Home} />
          <Route exact path="/classifiche" component={Home} />
          <Route exact path="/sconti" component={Home} />
          <Route exact path="/info" component={Home} />
          <Route exact path="/merch" component={Home} />
          <Route exact path='/login' component={Login} />
          <PrivateRoute exact path='/user' component={User} />
          <Route render={() => <Redirect to={{pathname: "/recensioni/all"}} />} />
        </Switch>
      </Router>
    </AuthProvider>
  );
};